import { yellow } from 'bold-ui/lib/styles/colors'
import { Acesso } from 'components/auth/model-useSession'

import { SoapSection } from '../SoapSection'
import AvaliacaoForm, { AvaliacaoFormProps } from './AvaliacaoForm'

export interface AvaliacaoSectionProps extends AvaliacaoFormProps {
  acessoProfissional: Acesso | null | undefined
}

export function AvaliacaoSection(props: Readonly<AvaliacaoSectionProps>) {
  return (
    <SoapSection initial='A' title='Avaliação' color={yellow}>
      <AvaliacaoForm {...props} />
    </SoapSection>
  )
}
